<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-08-11 16:31:38
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Roster\RosterForm\components\newShiftDialog.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-11-22 11:52:59
-->
<template>
  <normalDialog
    :title="$t('label_essweb_RosterForm_form_dialog_newShiftBtnTitle')"
    @close="closeDialog"
    width="600"
    :dialog="show"
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col>
            <AutoComplete
              isRequired
              :items="ShiftList"
              item-text="shift_name"
              item-value="uuid"
              multiple
              label="label_essweb_RosterForm_form_dialog_shiftNameLabel"
              small-chips
              chips
              single-line
              v-model="shift"
              :rules="$GetRules(['_Require_ArrRules'], [null])"
            >
            </AutoComplete>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:actions>
      <CardActions okBtn @cancel="closeDialog" @ok="toSave" />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "newShiftDialog",
  props: {
    show: { default: false, type: Boolean },
    curUuid: {
      default: () => {
        return [];
      },
      type: Array,
    },
  },
  computed: {
    ...mapGetters(["companyLang"]),
    ShiftList() {
      return this.$getSelectTrans(this.ShiftListData, "shift_name");
    },
    curShift() {
      let arr = [];
      const that = this;
      this.shift.map((item) => {
        let s = that.ShiftListData.find((ele) => ele.uuid === item);
        if (s) {
          arr.push(s);
        }
      });
      return arr;
    },
  },
  watch: {
    show(val) {
      if (val) {
        // this.shift = this.curUuid;//暂不用
      } else {
        if (this.$refs["form"]) this.$refs["form"].reset();
        this.shift = [];
      }
    },
  },
  data() {
    return {
      ShiftListData: [],
      shift: [],
    };
  },
  mounted() {
    this.getShiftList();
  },
  methods: {
    removeShift(item) {
      const index = this.shift.indexOf(item.uuid);
      if (index >= 0) this.shift.splice(index, 1);
    },
    getShiftList: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_shift",
        url: "/shift/get-shift-list/",
      }).then((res) => {
        that.ShiftListData = res.data;
      });
    },
    closeDialog: function () {
      this.$emit("close");
    },
    toSave: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$emit("onNew", this.curShift);
    },
  },
};
</script>
